import { render } from "./EMRDealKanbanView.vue?vue&type=template&id=4a92ae32&scoped=true"
import script from "./EMRDealKanbanView.vue?vue&type=script&lang=js"
export * from "./EMRDealKanbanView.vue?vue&type=script&lang=js"

import "./EMRDealKanbanView.vue?vue&type=style&index=0&id=4a92ae32&scoped=true&lang=css"
import "./EMRDealKanbanView.vue?vue&type=style&index=1&id=4a92ae32&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a92ae32"]])

export default __exports__